'use strict';

angular.module('webAgro1App').controller('ResumoAnotacoesCtrl', function($scope) {
  $scope.anotacoes = [];

  $scope.$on('anotacao', function(event, history, markers) {
    LoadAnotacoes(markers);
  });

  $scope.setAnimationMarker = function(marker, index) {
    if (!marker.isOpen) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      $scope.$emit('startAnimatingMarker', index);
    }
  };

  $scope.resetAnimationMarker = function(marker, index) {
    marker.setAnimation(null);
    $scope.$emit('stopAnimatingMarker', index);
  };

  $scope.openInfoWindow = function(marker, index) {
    $scope.resetAnimationMarker(marker);
    google.maps.event.trigger(marker, 'click');
    $scope.$emit('openMarkerPopup', index);
  };

  var reset = function() {
    delete $scope.anotacoes;
  };

  function LoadAnotacoes(markers) {
    $scope.anotacoes = markers.map(function(marker) {
      return {
        descricao: marker.objeto.observacoes || marker.objeto.estadio.descricao,
        usuario: marker.objeto.user.user_name,
        classificacao: marker.objeto.classificacao,
        marker: marker
      };
    });
  }

  $scope.$on('anotacao_close', reset);
  $scope.$on('reset', reset);

  $scope.$watch('tipo', function() {
    if ($scope.tipo === 'anotacao') {
      return LoadAnotacoes($scope.data);
    }
    reset();
  });
});
